// Hero (Lovable) — parallax drift + scroll-linked scrim, ported from the
// Lovable prototype's HeroScrim component. rAF-throttled, parallax skipped
// under prefers-reduced-motion (the 1.14 overscan stays static via CSS).
(function () {
  var section = document.querySelector('[data-hero-lovable]');
  if (!section) return;

  var img = section.querySelector('[data-hero-lovable-image]');
  var scrim = section.querySelector('[data-hero-lovable-scrim]');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var frame = 0;

  function update() {
    frame = 0;

    if (scrim) {
      var scrimOpacity = Math.min(1, 0.72 + window.scrollY / 900);
      scrim.style.opacity = scrimOpacity;
    }

    if (img && !reduceMotion) {
      var rect = section.getBoundingClientRect();
      var vh = window.innerHeight || 1;
      var progress = (rect.top + rect.height / 2 - vh / 2) / vh;
      var offset = progress * 0.2 * rect.height;
      img.style.transform = 'translate3d(0, ' + offset + 'px, 0) scale(1.14)';
    }
  }

  function onScroll() {
    if (!frame) frame = requestAnimationFrame(update);
  }

  update();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
})();
